import { CommonTextProps } from "./CommonTextProps";
import cx from "classnames";
import "./bodyG4P.css";

import { palette, PaletteColor} from "../styles";

import {Tooltip} from "@g4p/react-styleguide-library";
import {InfoLargeIcon as InfoIcon} from "@g4p/react-styleguide-library";
import {LocalizedString} from "../Children";
import {BodyStyled, BodyTooltipWrapperStyled, InfoIconTooltipStyled} from "./bodyStyles";
import {textChildrenToChildren} from "./utils";
import {iconSizes} from "../Icons/Icon";

type Props = CommonTextProps & {
    align?: "left" | "center" | "right";
    component?: keyof JSX.IntrinsicElements;
    color?: PaletteColor;
    "data-test-id"?: string;
    ariaLabel?: string;
} & {
    size:
        | "xx-small"
        | "x-small"
        | "small"
        | "medium"
        | "large"
        | "x-large"
        | "custom-large";
    weight: "regular" | "medium" | "bold";
    description?: LocalizedString | LocalizedString[];
    separator?: string;
    noNbspSeparator?: boolean;
    activeAccessibleElements?: boolean;
};

// Can only have `regular` and `medium` for `xx-small`, `x-small` and `small` sizes.

export function Body(props: Props) {

    const descriptionTooltip = props.description && (
        <BodyTooltipWrapperStyled $size={props.size}>
            <Tooltip title={props.description} >
                <InfoIcon
                    width={iconSizes.default}
                    height={iconSizes.default}
                    color={palette.blue800}
                />
            </Tooltip>
        </BodyTooltipWrapperStyled>
    );

    return (
        <>
            {props.ariaLabel && <span className={"screen-reader-only"}>{props.ariaLabel}</span>}
            <div
                style={{ display: "contents" }}
                {...(props.ariaLabel !== undefined && !props.activeAccessibleElements && {ariaHidden: true})}
            >
        <BodyStyled
            id={props.id}
            $size={props.size}
            $weight={props.weight}
            $color={props.color}
            $overflowWrap={props.overflowWrap}
            $textAlign={props.align || "left"}
            className={cx(props.className)}
            data-test-id={props["data-test-id"]}
            {...!props.activeAccessibleElements && {ariaLabel: props.ariaLabel}}
        >
            {textChildrenToChildren(props.children, props.separator, props.noNbspSeparator, props.activeAccessibleElements)}
            {props.description && (
                <InfoIconTooltipStyled
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                    {...(props.ariaLabel && props.activeAccessibleElements && {ariaHidden: true})}
                >
                    {descriptionTooltip}
                </InfoIconTooltipStyled>
            )}
        </BodyStyled>
            </div>
            </>
    );
}